import { useState } from 'react';
import { useLocation } from 'react-router';

import CommunitySecion from './ArticlePage/Section';
import CommunityArticlePage from './ArticlePage';
import WriteButton from './WriteButton';

import * as S from './style';

const CommunityPage = () => {
  const { pathname } = useLocation();
  const [tag, setTag] = useState('ALL'); // PARSE_CATEGORY의 value가 들어옴
  const [searchData, setSearchData] = useState('');

  const isQna = pathname.includes('qna') ? true : false;

  return (
    <>
      <CommunitySecion
        route={pathname.replace('/community/', '') ?? ''}
        searchData={searchData}
        setSearchData={setSearchData}
      />
      <S.Container>
        <CommunityArticlePage
          tag={tag}
          search={searchData}
          setTag={setTag}
          isQna={isQna}
        />
      </S.Container>
      {!isQna && <WriteButton to="/community/information/write" />}
    </>
  );
};

export default CommunityPage;
